import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut as fbSignOut,
  updateProfile,
  type User,
  type UserCredential,
} from 'firebase/auth';
import { getAuthInstance, googleProvider } from './firebase';

export interface SignUpResult {
  user: User;
}

export async function signUpEmail(
  email: string,
  password: string,
  displayName?: string,
): Promise<SignUpResult> {
  const auth = getAuthInstance();
  const trimmedName = displayName?.trim() || undefined;
  const result = await createUserWithEmailAndPassword(auth, email, password);
  if (trimmedName) {
    await updateProfile(result.user, { displayName: trimmedName });
    await result.user.reload();
  }
  return { user: result.user };
}

export async function signInEmail(email: string, password: string): Promise<UserCredential> {
  return signInWithEmailAndPassword(getAuthInstance(), email, password);
}

export async function signInGoogle(): Promise<UserCredential> {
  return signInWithPopup(getAuthInstance(), googleProvider);
}

export async function sendReset(email: string): Promise<void> {
  await sendPasswordResetEmail(getAuthInstance(), email);
}

export async function signOut(): Promise<void> {
  await fbSignOut(getAuthInstance());
}

export function authErrorToVietnamese(err: unknown): string {
  const code = (err as { code?: string })?.code ?? '';
  switch (code) {
    case 'auth/invalid-email':
      return 'Email không hợp lệ.';
    case 'auth/email-already-in-use':
      return 'Email này đã được đăng ký. Hãy đăng nhập.';
    case 'auth/weak-password':
      return 'Mật khẩu quá yếu (tối thiểu 6 ký tự).';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'Email hoặc mật khẩu không đúng.';
    case 'auth/too-many-requests':
      return 'Bạn thử quá nhiều lần. Hãy đợi một lát.';
    case 'auth/network-request-failed':
      return 'Mất kết nối mạng. Hãy thử lại.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return 'Bạn đã đóng cửa sổ đăng nhập.';
    case 'auth/popup-blocked':
      return 'Trình duyệt chặn popup. Hãy bật popup cho trang này.';
    case 'auth/requires-recent-login':
      return 'Vui lòng đăng nhập lại để tiếp tục.';
    default:
      // Never leak raw library/SDK messages — fall back to a generic Vietnamese line.
      return 'Có lỗi xảy ra. Hãy thử lại.';
  }
}
